import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //add event listener on click js-btn-cote
        document.querySelector('.js-btn-cote').addEventListener('click', () => {
            let randomInt = Math.floor(Math.random() * 100);
            //fetch cote d'Eau on wp endpoint
            fetch('/wp-json/wp/v2/cote-deau?'+randomInt)
                .then(response => response.json())
                .then(data => {
                    //js-modification-date, js-cote, js-prevision
                    document.querySelector('.js-modification-date').innerHTML = data.maj;
                    document.querySelector('.js-cote').innerHTML = data.cote;
                    document.querySelector('.js-prevision').innerHTML = data.prevision;
                });
            document.querySelector('.js-modification-date').innerHTML = '...';
            document.querySelector('.js-cote').innerHTML = '...';
            document.querySelector('.js-prevision').innerHTML = '...';
        });

        //js-btn-activities
        document.querySelector('.js-btn-activities').addEventListener('click', () => {
            let randomInt = Math.floor(Math.random() * 100);
            //fetch cote d'Eau on wp endpoint
            fetch('/wp-json/wp/v2/activites?'+randomInt)
                .then(response => response.json())
                .then(data => {
                    //js-modification-date, js-cote, js-prevision
                    document.querySelector('.js-activites').innerHTML = data;
                });
            document.querySelector('.js-activites').innerHTML = '...';
        });
    }

    destroy() {
        //remove event listener on click js-btn-cote
        document.querySelector('.js-btn-cote').removeEventListener('click', () => {
            //fetch cote d'Eau on wp endpoint
            fetch('/wp-json/wp/v2/cote-deau')
                .then(response => response.json())
                .then(data => {
                    //js-modification-date, js-cote, js-prevision
                    document.querySelector('.js-modification-date').innerHTML = data.maj;
                    document.querySelector('.js-cote').innerHTML = data.cote;
                    document.querySelector('.js-prevision').innerHTML = data.prevision;
                });
            document.querySelector('.js-modification-date').innerHTML = '...';
            document.querySelector('.js-cote').innerHTML = '...';
            document.querySelector('.js-prevision').innerHTML = '...';
        });

        //js-btn-activities
        document.querySelector('.js-btn-activities').removeEventListener('click', () => {
            //fetch cote d'Eau on wp endpoint
            fetch('/wp-json/wp/v2/activites')
                .then(response => response.json())
                .then(data => {
                    //js-modification-date, js-cote, js-prevision
                    document.querySelector('.js-activites').innerHTML = data;
                });
            document.querySelector('.js-activites').innerHTML = '...';
        });

    }
}
